export const baseURL = process.env.REACT_APP_BASE_URL;
export const timeout = 30000;
export const socketURL = process.env.REACT_APP_SOCKET_URL;
export const appUrl = process.env.REACT_APP_APP_URL;
export const currency = 'تومان';
export const freightSocketURL = `${socketURL}/freight`;
export const adminSocketURL = `${socketURL}/admin`;
export const neshanURL = `https://api.neshan.org/`;
export const neshanKEY = `service.R6ryghkVzFghqYpPnfEXRolBrjOCuyVlFnUVEfQe`;
export const firebase = {
  apiKey: 'AIzaSyD1550-HllDp-jF351PyjX_UvsFR3l32Aw',
  authDomain: 'rahamsafer-d0000.firebaseapp.com',
  databaseURL: 'https://rahamsafer-d0000.firebaseio.com',
  projectId: 'rahamsafer-d0000',
  storageBucket: 'rahamsafer-d0000.appspot.com',
  messagingSenderId: '427653721292',
  appId: '1:427653721292:web:0bd436e36206311e6c6669',
  measurementId: 'G-XPX9GD2ZW2',
};
export const orderStatusArray = {
  pending: 'درحال بررسی',
  sendToFreight: 'باربری',
  sendToAdmin: 'مدیرسیستم',
  tendering: 'مناقصه',
  returned: 'برگشت بار',
  rejected: 'رد بار',
  getWaybill: 'صدور بارنامه',
  movingTowardsOrigin: 'بارگیری',
  transporting: 'درحال حمل',
  delivered: 'تحویل شده',
  canceled: 'کنسل بار',
};
export const actionList = {
  pending: ['sendToAdmin', 'tendering', 'returned', 'rejected', 'canceled'],
  sendToFreight: [
    'sendToAdmin',
    'tendering',
    'returned',
    'rejected',
    'canceled',
  ],
  sendToAdmin: ['sendToAdmin', 'tendering', 'returned', 'rejected', 'canceled'],
  tendering: ['tendering', 'rejected', 'returned', 'canceled'],
  returned: ['pending', 'sendToAdmin', 'tendering', 'rejected', 'canceled'],
  rejected: ['pending', 'sendToAdmin', 'returned', 'canceled'],
  getWaybill: ['tendering', 'getWaybill'],
  movingTowardsOrigin: ['getWaybill', 'tendering', 'transporting'],
  transporting: ['movingTowardsOrigin', 'tendering', 'delivered'],
  delivered: ['transporting', 'rejected'],
  canceled: ['pending', 'sendToAdmin', 'tendering', 'canceled'],
};
